import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';
import '../../../Golden.scss';

const Golden = ({isFirst=true, isSecond, elements, row=true}) => { 
    if (elements.length === 0) {
        return [];
    }
    let className = "golden";
    if (row) {
        className += " golden-row";
    } else {
        className += " golden-column";
    }

    if (isFirst) {
        className += " initial";
    }


    let children = [
        <Golden isSecond={isFirst} isFirst={false} elements={elements.slice(1)} row={!row}/>,
          <div className="golden-element">
            {elements[0]}
          </div>
    ];
    if (!row && elements.length > 4) {
        children.reverse();
    } else if (elements.length == 3) {
        children.reverse();
    }
    return (
        <div className={className}>
          {children}
       </div>);
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Golden);
